// extracted by mini-css-extract-plugin
export var section = "leadership-module--section--2xeqg";
export var hero = "leadership-module--hero--2O7SI";
export var controls = "leadership-module--controls--1soRt";